﻿module.exports = function ($scope) {
     
    $scope.setProjectPage = function () {
        $scope.isProjectPage = true;
    }

    $scope.setPage = function (meta) {
        $scope.page = meta;
    }
    //
    $scope.setTitle = function (title) {
        $scope.pageTitle = title;
        $("title").html(title)
    };
    //
    $scope.setPageClass = function (pageClass) {
        $scope.pageClass = pageClass;
    };
    //
    //
    $scope.switchPage = function (e) {
        e.preventDefault();
        $scope.page = this.l.meta;
        $scope.currentPage = 'views/pages/' + $scope.page + '.html';

    }
    $scope.toHome = function (e) {
        e.preventDefault();
        $scope.page = "home";
        $scope.currentPage = 'views/pages/' + $scope.page + '.html';
    }
}


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/comp/paging.js
// module id = 10
// module chunks = 0